/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_ButtonInputs */

const en_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete account`)
};

const id_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus akun`)
};

const ms_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padamkan akaun`)
};

const ca_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina el compte`)
};

const cs_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstranit účet`)
};

const da_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet konto`)
};

const de_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto löschen`)
};

const et_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kustuta konto`)
};

const es_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

const fr_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le compte`)
};

const hr_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izbriši račun`)
};

const it_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina account`)
};

const lv_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzēst kontu`)
};

const lt_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ištrinti paskyrą`)
};

const hu_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiók törlése`)
};

const nl_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account verwijderen`)
};

const nb_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slett konto`)
};

const pl_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń konto`)
};

const pt_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir conta`)
};

const ro_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge contul`)
};

const sk_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vymazať účet`)
};

const sl_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izbriši račun`)
};

const fi_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista tili`)
};

const sv_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera konto`)
};

const vi_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa tài khoản`)
};

const tr_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabı sil`)
};

const el_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διαγραφή λογαριασμού`)
};

const bg_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване на акаунт`)
};

const ru_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить аккаунт`)
};

const sr_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избриши налог`)
};

const uk_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити акаунт`)
};

const ka_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ანგარიშის წაშლა`)
};

const hi_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अकाउंट डिलीट करें`)
};

const th_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบบัญชี`)
};

const ko_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 삭제`)
};

const zh_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除账户`)
};

const zh_tw_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刪除帳戶`)
};

const ja_delete_account_button = /** @type {(inputs: Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを削除`)
};

/**
* | output |
* | --- |
* | "Delete account" |
*
* @param {Delete_Account_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const delete_account_button = /** @type {((inputs?: Delete_Account_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_delete_account_button(inputs)
	if (locale === "ms") return ms_delete_account_button(inputs)
	if (locale === "ca") return ca_delete_account_button(inputs)
	if (locale === "cs") return cs_delete_account_button(inputs)
	if (locale === "da") return da_delete_account_button(inputs)
	if (locale === "de") return de_delete_account_button(inputs)
	if (locale === "et") return et_delete_account_button(inputs)
	if (locale === "es") return es_delete_account_button(inputs)
	if (locale === "fr") return fr_delete_account_button(inputs)
	if (locale === "hr") return hr_delete_account_button(inputs)
	if (locale === "it") return it_delete_account_button(inputs)
	if (locale === "lv") return lv_delete_account_button(inputs)
	if (locale === "lt") return lt_delete_account_button(inputs)
	if (locale === "hu") return hu_delete_account_button(inputs)
	if (locale === "nl") return nl_delete_account_button(inputs)
	if (locale === "nb") return nb_delete_account_button(inputs)
	if (locale === "pl") return pl_delete_account_button(inputs)
	if (locale === "pt") return pt_delete_account_button(inputs)
	if (locale === "ro") return ro_delete_account_button(inputs)
	if (locale === "sk") return sk_delete_account_button(inputs)
	if (locale === "sl") return sl_delete_account_button(inputs)
	if (locale === "fi") return fi_delete_account_button(inputs)
	if (locale === "sv") return sv_delete_account_button(inputs)
	if (locale === "vi") return vi_delete_account_button(inputs)
	if (locale === "tr") return tr_delete_account_button(inputs)
	if (locale === "el") return el_delete_account_button(inputs)
	if (locale === "bg") return bg_delete_account_button(inputs)
	if (locale === "ru") return ru_delete_account_button(inputs)
	if (locale === "sr") return sr_delete_account_button(inputs)
	if (locale === "uk") return uk_delete_account_button(inputs)
	if (locale === "ka") return ka_delete_account_button(inputs)
	if (locale === "hi") return hi_delete_account_button(inputs)
	if (locale === "th") return th_delete_account_button(inputs)
	if (locale === "ko") return ko_delete_account_button(inputs)
	if (locale === "zh") return zh_delete_account_button(inputs)
	if (locale === "zh-tw") return zh_tw_delete_account_button(inputs)
	if (locale === "ja") return ja_delete_account_button(inputs)
	return en_delete_account_button(inputs)
});